import { render, staticRenderFns } from "./sdproduct8.vue?vue&type=template&id=eadf506e&scoped=true"
import script from "./sdproduct8.vue?vue&type=script&lang=js"
export * from "./sdproduct8.vue?vue&type=script&lang=js"
import style0 from "./sdproduct8.vue?vue&type=style&index=0&id=eadf506e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadf506e",
  null
  
)

export default component.exports